import i18n from 'i18next';
import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .required(i18n.t('header.login.errorMsg.required')!)
    .email(i18n.t('header.login.errorMsg.email')!),
  password: Yup.string().required(i18n.t('header.login.errorMsg.required')!),
});
